import type {
	PanStart,
	Point,
	Transform,
} from "web_myplann/Chat/Types/pinchZoom";

export const getPanTransform = (start: PanStart, point: Point): Transform => ({
	scale: start.transform.scale,
	x: start.transform.x + point.x - start.point.x,
	y: start.transform.y + point.y - start.point.y,
});
